module.exports = __webpack_public_path__ + "media/slide4/contractMediaSlide4Part1-85639619.png";